import MagstimTable from './MagstimTable';

import { CurrentLang } from 'common';

class MagstimTableTreatmentHistoryBase extends MagstimTable {

	initForSelect = (data) => {
		this.initTable(this.configTable(data), true);
	}

    getColumns(dataIsEmpty) {
        return [
			{ title: CurrentLang().treatment_history_table_columnname_date, property: 'date', isSearchable: true, formatter: dataIsEmpty ? undefined : this.formatDateAndTime },
			{ title: CurrentLang().treatment_history_table_columnname_individualTreatment, property: 'individualTreatment' },
			{ title: CurrentLang().treatment_history_table_columnname_completed, property: 'completed', formatter: dataIsEmpty ? undefined : this.formatFraction },
			{ title: CurrentLang().treatment_history_table_columnname_performedBy, property: 'performedBy', isSearchable: true },
			{ title: CurrentLang().treatment_history_table_columnname_totalPulses, property: 'totalPulses' },
			
			{ title: CurrentLang().device, property: 'deviceUsed', isExportOnly: true, optional: true },
			{ title: CurrentLang().treatment_history_table_device_guid, property: 'deviceUsedGuid', isExportOnly: true, optional: true },
			
			{ title: CurrentLang().treatment_history_table_managing_physician_name, property: 'managingPhysician', isExportOnly: true, optional: true },
			{ title: CurrentLang().treatment_history_table_managing_physician_email, property: 'managingPhysicianEmail', isExportOnly: true, optional: true },
			{ title: CurrentLang().treatment_history_table_managing_physician_guid, property: 'managingPhysicianGuid', isExportOnly: true, optional: true },
			
			{ title: CurrentLang().treatment_history_table_referring_physician_name, property: 'referringPhysician', isExportOnly: true, optional: true },
			{ title: CurrentLang().treatment_history_table_referring_physician_email, property: 'referringPhysicianEmail', isExportOnly: true, optional: true },
			{ title: CurrentLang().treatment_history_table_referring_physician_guid, property: 'referringPhysicianGuid', isExportOnly: true, optional: true },
			
			{ title: CurrentLang().contact_within_tolerance_count, property: 'ContactWithinToleranceCount', isExportOnly: true, optional: true },
			{ title: CurrentLang().distance_within_tolerance_count, property: 'DistanceWithinToleranceCount', isExportOnly: true, optional: true },
			{ title: CurrentLang().rotation_within_tolerance_count, property: 'RotationWithinToleranceCount', isExportOnly: true, optional: true },
			{ title: CurrentLang().tilt_within_tolerance_count, property: 'TiltWithinToleranceCount', isExportOnly: true, optional: true },
			{ title: CurrentLang().stimuli_within_tolerance_count, property: 'StimuliWithinToleranceCount', isExportOnly: true, optional: true },
		];
    }

	configTable(data) {
		//console.log('MagstimTableTreatmentHistory.configTable', data);
		const dataIsEmpty = (null === data) || (undefined === data) || (0 === data.length);
		if (dataIsEmpty) {
			data = [];
			data[0] = {
				date: CurrentLang().no_data_words,
				individualTreatment: CurrentLang().no_data_words,
				completed: CurrentLang().no_data_words,
				performedBy: CurrentLang().no_data_words,
				totalPulses: CurrentLang().no_data_words,
				__dummy_no_data_row: true
			};
		}

		return {
			columns: this.getColumns(dataIsEmpty),
			data: data
		};
    }
    
	resetFilters() {
		super.resetFilters();
		// this.addFilter('clinician', 'Bob');
	}

}

export default MagstimTableTreatmentHistoryBase;